import { FunctionComponent } from 'react';
import styled from 'styled-components';

interface DotProps {
  color?: string;
  size?: number;
  areaWidth?: number;
}
const Dot: FunctionComponent<DotProps> = ({
  color = '#A9AEB1',
  size = 3,
  areaWidth,
}) => {
  return (
    <StyledSvg
      width={size}
      height={size}
      areaWidth={areaWidth}
      viewBox="0 0 3 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.5" cy="1.5" r="1.5" fill={color} />
    </StyledSvg>
  );
};

export default Dot;

const StyledSvg = styled.svg<{ areaWidth?: number }>`
  ${({ areaWidth }) => `width: ${areaWidth}px`}
`;
